import { DEFAULT_VALUE } from "@/constants";

export const API = {
  GET_ALL_BLOCKS: (
    limit: number = DEFAULT_VALUE.limit,
    chain: string,
    currentPage: number = DEFAULT_VALUE.page
  ) => `block/getAllBlocks?limit=${limit}&page=${currentPage}&chain=${chain}`,
  GET_SAFE_BLOCK: (chain: string) => `block/getSafeBlockDetails?chain=${chain}`,
  GET_ALL_TXN: (
    limit: number = DEFAULT_VALUE.limit,
    chain: string,
    currentPage: string | number = DEFAULT_VALUE.page,
    value?: string | number
  ) =>
    `transaction/getAllTransactions?limit=${limit}&page=${currentPage}${
      value ? `&value=${value}` : ""
    }&chain=${chain}`,
  GET_DETAILS_TXN: (txnHash: string, chain: string) =>
    `transaction/getTransactionDetails?txnHash=${txnHash}&chain=${chain}`,
  GET_DETAILS_BLOCKS: (blockHash: string, chain: string) =>
    `block/getBlockDetails?block=${blockHash}&chain=${chain}`,
  SEARCH: (query: string | number, chain: string) =>
    `search?searchQuery=${query}&chain=${chain}`,
  GET_ADDRESS_INFO: (address: string, chain: string) =>
    `transaction/getAddressInfo?address=${address}&chain=${chain}`,
  GET_DETAILS_ADDRESS: (
    address: string,
    limit: number = DEFAULT_VALUE.limit,
    page: number | string = DEFAULT_VALUE.page,
    chain: string
  ) =>
    `/transaction/getTransactionByAddress?address=${address}&limit=${
      limit
    }&page=${page}&chain=${chain}`,
  GET_FAUCET: (
    value: number,
    chain: string,
    limit: number = DEFAULT_VALUE.limit
  ) => `transaction/faucetHistory?limit=${limit}&page=${value}&chain=${chain}`,
  FAUCET: () => `transaction/faucetTransfer`,
  HISTORY_GRAPH: (chain: string, interval?: string) =>
    `transaction/getTransactionHistory?chain=${chain}${
      interval ? `&value=${interval}` : ""
    }`,
  GET_ALL_CONTRACTS: (chain: string, page: number = DEFAULT_VALUE.page) =>
    `contract/getAllContracts?page=${page}&chain=${chain}`,
  GET_CONTRACT_DETAILS: (
    value: string,
    limit: number = DEFAULT_VALUE.limit,
    page: number = DEFAULT_VALUE.page
  ) =>
    `contract/getTransfersByContractAddress?contractAddress=${value}&limit=${
      limit
    }&page=${page}`,
  GET_CONTRACT_OVERVIEW: (value: string) =>
    `contract/getContractsDetails?value=${value}`,
  GET_TOKEN: (
    page: number = DEFAULT_VALUE.page,
    limit: number = DEFAULT_VALUE.limit
  ) => `token/getTokenList?limit=${limit}&page=${page}`,
  GET_HOLDER: (value: string, page: number = DEFAULT_VALUE.page) =>
    `token/getHolders?contractAddress=${value}&page=${page}`,
  GET_METHODS: (value: string, type: string, proxy: boolean) =>
    `contract/getMethods?contractAddress=${value}&type=${type}&proxy=${proxy}`,
  POST_READ_METHODS: () => `contract/executeMethod`,
  POST_CONTRACT_VERIFICATION: () => `contract/verifyContract`,
  GET_CONTRACT_META_DATA: (address: string) =>
    `contract/getContractMetadata?contractAddress=${address}`,
  GET_TOKEN_TXNS: (page: number = DEFAULT_VALUE.page) =>
    `token/getTokenTransfers?page=${page}`,
  GET_EVENT_TRANSFERS: (address: string, page: number = DEFAULT_VALUE.page) =>
    `transaction/eventTransfers?contractAddress=${address}&page=${page}`,
  POST_PROXY: () => `contract/isProxy`,
  GET_SEARCH_NAME: (value: string, filter: string) =>
    `search/token?value=${value}&filter=${filter}`,
};
